<div class="container">
  <div class="row">
    <div class="col-sm-8 col-sm-offset-2">
      <h3>{{ appCopy.panelHeader['pageNotFoundTitle'+selectedLanguage] }}</h3>
      <p>{{ appCopy.panelHeader['pageNotFoundMessage'+selectedLanguage] }}</p>
    </div>
  </div>
</div>